import React, {useCallback, useRef, useState} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {useClickOutside} from 'app/utils/useClickOutside';

interface PropsInterface {
    descriptionTooltipTranslateKey: string
    classTooltip?: string
    iconSvg?: string
}

const SmartIconTooltip = ({
    descriptionTooltipTranslateKey,
    classTooltip,
    iconSvg
}: PropsInterface): React.ReactElement => {
    const [isOpen, setIsOpen] = useState(false);
    const tooltipRef = useRef<HTMLDivElement>(null);

    const handleToggle = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setIsOpen(open => !open);
    }, []);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    useClickOutside(tooltipRef, handleClose, isOpen);

    return <div className="label-tooltip label-tooltip_icon" ref={tooltipRef}>
        <div className={`field__tooltip ${classTooltip || 'default-position'}${isOpen ? ' is-open' : ''}`}>
            <button
                type="button"
                className="icon"
                onClick={handleToggle}
                aria-expanded={isOpen}
            >
                <SpriteIcon
                    name={iconSvg ? `#${iconSvg}` : '#svg-icon-tooltip'}
                    className="svg-default"
                />
            </button>
            <div className="container-description">
                <div className="description">
                    <p>{I18n.t(descriptionTooltipTranslateKey)}</p>
                </div>
            </div>
        </div>
    </div>;
};

export default SmartIconTooltip;
